import { render } from "./Notification_detail.vue?vue&type=template&id=a5e12a2c&scoped=true"
import script from "./Notification_detail.vue?vue&type=script&lang=js"
export * from "./Notification_detail.vue?vue&type=script&lang=js"

import "./Notification_detail.vue?vue&type=style&index=0&id=a5e12a2c&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\project\\forex\\vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5e12a2c"]])

export default __exports__